import { CurrencyType, PLN } from '@constants/currencies'
import { getVoucherValueForFreePlanPromotion } from '@pages/Checkout/helpers/getVoucherValue'
import {
  Badge,
  Heading,
  Paragraph,
  Price,
  PriceDescription,
  Spacer
} from '@ui-kit'
import { Fragment } from 'react'
import { Trans, useTranslation } from 'react-i18next'

export const PromotionForFreePlan = ({
  price,
  regularPrice,
  currency,
  isPLNCurrency
}: {
  price: number
  regularPrice: number
  currency: CurrencyType
  isPLNCurrency: boolean
}) => {
  const { t } = useTranslation()

  const voucherValue = t(getVoucherValueForFreePlanPromotion(currency))

  return (
    <Fragment>
      <Price amount={price} currency={currency}>
        <PriceDescription>
          {currency === PLN && t('change.plan.page.net')}{' '}
          {t('change.plan.page.per.month')}
        </PriceDescription>
      </Price>

      <Paragraph size={14} color='neutral-6'>
        <del>
          {regularPrice.toFixed(2)} {currency}{' '}
          {isPLNCurrency && t('change.plan.page.net')}
        </del>
      </Paragraph>

      <Spacer space={5} />

      <Badge variant='warning20-filled' weight={600}>
        {t('promotion.for.free.plan.50percent.x.1month')}
      </Badge>

      <Spacer space={5} />

      <Heading level={5} color='warning'>
        <Trans
          i18nKey='checkout.plans.plan.free.plan.promotion.voucher'
          values={{
            voucherValue
          }}
        />
      </Heading>

      <Spacer space={5} />

      <Heading level={5} color='warning'>
        {t('checkout.plans.plan.free.plan.promotion.credits')}
      </Heading>
    </Fragment>
  )
}

PromotionForFreePlan.displayName = 'CheckoutPlansBannersPromotionForFreePlan'
